import { setFetchStartState } from '../fetchLoadable.js';
import { createNotLoaded } from '../Loadable/utils.js';
import * as actionTypes from './actionTypes.js';
const defaultFilter = {
    selectedTypes: [],
    selectedTemplates: [],
    selectedCreditors: [],
    includePausedCases: true,
};
export const interactionsReducer = (state = {
    incoming: {
        filter: { ...defaultFilter },
        data: createNotLoaded(),
    },
    outgoing: {
        filter: { ...defaultFilter },
        data: createNotLoaded(),
    },
}, action) => {
    switch (action.type) {
        case actionTypes.FETCH_OUTGOING_START:
            return {
                ...state,
                outgoing: {
                    ...state.outgoing,
                    data: setFetchStartState(state.outgoing.data, action.payload),
                },
            };
        case actionTypes.FETCH_OUTGOING_SUCCESS:
        case actionTypes.FETCH_OUTGOING_ERROR:
            return {
                ...state,
                outgoing: {
                    ...state.outgoing,
                    data: { ...action.payload.res },
                },
            };
        case actionTypes.SET_OUTGOING_FILTER:
            return {
                ...state,
                outgoing: {
                    ...state.outgoing,
                    filter: { ...action.payload },
                },
            };
        case actionTypes.FETCH_INCOMING_START:
            return {
                ...state,
                incoming: {
                    ...state.incoming,
                    data: setFetchStartState(state.incoming.data, action.payload),
                },
            };
        case actionTypes.FETCH_INCOMING_SUCCESS:
        case actionTypes.FETCH_INCOMING_ERROR:
            return {
                ...state,
                incoming: {
                    ...state.incoming,
                    data: { ...action.payload.res },
                },
            };
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map